// extracted by mini-css-extract-plugin
export var button = "button-module--button--kuQ6g";
export var buttonPrimary = "button-module--buttonPrimary--ezBT4 button-module--button--kuQ6g";
export var buttonSecondary = "button-module--buttonSecondary--Vz9K7 button-module--button--kuQ6g";